import type { QueryClient } from '@tanstack/react-query';

/** Consultas que dependen del stock: se refrescan tras cualquier operación con palets. */
const STOCK_QUERY_ROOTS = [
  'pallets',
  'map',
  'inventory',
  'locations',
  'search',
  'dashboard',
  'outbound',
  'clients',
  'products',
];

export async function invalidateStock(queryClient: QueryClient): Promise<void> {
  await Promise.all(
    STOCK_QUERY_ROOTS.map((root) => queryClient.invalidateQueries({ queryKey: [root] })),
  );
}

/** Intervalo de refresco de las pantallas "en tiempo real" (mapa, inventario, panel). */
export const LIVE_REFRESH_MS = 15_000;
